import { Avatar, Box, Divider, Flex, Heading, HStack, Icon, Text } from "@chakra-ui/react";
import { FiCalendar, FiChevronRight, FiPlayCircle, FiShield } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import { VotingViewModel } from "../../VotingViewModel";
import { observer } from "mobx-react-lite";

export const VotingInfoTile: React.FC<{ model: VotingViewModel }> = observer(({ model }) => (
  <Box w="100%" bg="white" borderRadius="22px" border="1px solid rgba(67,0,152,0.08)" boxShadow="0 8px 26px rgba(67,0,152,0.06)" p={{ base: "24px", md: "30px" }}>
    <HStack justify="space-between" wrap="wrap" gap="10px" mb="16px">
      <HStack spacing="6px" bg="rgba(47,206,37,0.12)" color="#1f9e18" px="11px" py="5px" borderRadius="full">
        <Icon as={FiPlayCircle} boxSize="14px" />
        <Text fontSize="13px" fontWeight="700">
          Trwa
        </Text>
      </HStack>
      {model.endDate && (
        <HStack spacing="7px" color="gray.500" fontSize="13px">
          <Icon as={FiCalendar} boxSize="14px" />
          <Text>Do {model.endDate}</Text>
        </HStack>
      )}
    </HStack>

    <Heading fontSize={{ base: "24px", md: "30px" }} fontWeight="800" color="primary" lineHeight="1.2" mb="16px">
      {model.name}
    </Heading>

    {model.organizer?.name && (
      <HStack
        spacing="11px"
        role="group"
        {...(model.organizer.profileRef
          ? {
              as: RouterLink,
              to: `/profil/${model.organizer.profileRef}`,
              w: "fit-content",
              maxW: "100%",
              borderRadius: "12px",
              p: "6px",
              ml: "-6px",
              transition: "all 0.12s",
              _hover: { bg: "rgba(67,0,152,0.05)" }
            }
          : {})}
      >
        <Avatar size="sm" name={model.organizer.name} src={model.organizer.imageUrl} bg="primary" color="white" />
        <Box minW={0}>
          <Text fontSize="12px" color="gray.400" fontWeight="600">
            Organizator
          </Text>
          <HStack spacing="6px">
            <Text fontSize="15px" fontWeight="700" color="primary" noOfLines={1}>
              {model.organizer.name}
            </Text>
            {model.organizer.profileRef && <Icon as={FiChevronRight} color="primary" boxSize="15px" _groupHover={{ transform: "translateX(2px)" }} transition="transform 0.12s" />}
          </HStack>
        </Box>
      </HStack>
    )}

    <Divider my="20px" borderColor="rgba(67,0,152,0.08)" />

    <Flex align="center" gap="10px" bg="rgba(67,0,152,0.04)" borderRadius="14px" p="13px 16px">
      <Icon as={FiShield} color="primary" boxSize="18px" flexShrink={0} />
      <Text fontSize={{ base: "13px", md: "14px" }} color="gray.600" lineHeight="1.5">
        Twój głos jest chroniony, a wynik zostanie zakotwiczony na blockchainie — sprawdzalny przez każdego.
      </Text>
    </Flex>
  </Box>
));
